import { Box, Grid, GridSize } from "@material-ui/core";
import { selectIsInsightExpanded } from "modules/customer/tools/location/locationSlice";
import React from "react";
import NumberOfStores from "./NumberOfStores";
import { useAppSelector } from "store";
import IndependentsPercentage from "./IndependentsPercentage";
import MostCommonStoreSize from "./MostCommonStoreSize";
import NumberOfStoresPerCategory from "./NumberOfStoresPerCategory";

const RetailPresence: React.FC = () => {
    const isInsightExpanded = useAppSelector(selectIsInsightExpanded);
    const kpiGridSize: GridSize = isInsightExpanded ? 6 : 12;

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={kpiGridSize}>
                    <NumberOfStores />
                </Grid>
                <Grid item xs={kpiGridSize}>
                    <IndependentsPercentage />
                </Grid>
                <Grid item xs={kpiGridSize}>
                    <MostCommonStoreSize />
                </Grid >
                <Grid item xs={12}>
                    <NumberOfStoresPerCategory />
                </Grid>
            </Grid>
        </Box>
    );
};

export default RetailPresence;
